import React from 'react';
import { Link } from 'react-router';
import s from './header.module.css';

interface Props {}

export default function ContentPageHeader({}: Props) {
  return (
    <header>
      <nav className="navigation">
        <div>
          <h3>
            <Link to="/">
              <img className={s.vinylImg} alt="Fadila" src="/icons/fadila-disc-64.png" />
              Fadila
            </Link>
          </h3>
        </div>
        <ul className="menu align-center">
          <li className={s.navListItem}>
            <Link to={'/app'}>App</Link>
          </li>
          <li className={s.navListItem}>
            {/* A plain anchor: /privacy is a static file, not a route. */}
            <a href="/privacy">Privacy</a>
          </li>
          <li className={s.navListItem}>
            <Link to={'/help'}>Help</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}
